/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_User_Devices_DescriptionInputs */

const es_walkthrough_user_devices_description = /** @type {(inputs: Walkthrough_User_Devices_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisá todos los dispositivos conectados a tu cuenta. Podés revocar el acceso desde cualquier dispositivo que no reconozcas.`)
};

const en_walkthrough_user_devices_description = /** @type {(inputs: Walkthrough_User_Devices_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See every device currently signed into your account. You can revoke access from any device you don't recognize.`)
};

/**
* | output |
* | --- |
* | "See every device currently signed into your account. You can revoke access from any device you don't recognize." |
*
* @param {Walkthrough_User_Devices_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_user_devices_description = /** @type {((inputs?: Walkthrough_User_Devices_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_User_Devices_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_user_devices_description(inputs)
	return en_walkthrough_user_devices_description(inputs)
});
export { walkthrough_user_devices_description as "walkthrough.user_devices_description" }